import { render } from "./ViewFournisseur.vue?vue&type=template&id=7c991a9f&ts=true"
import script from "./ViewFournisseur.vue?vue&type=script&lang=ts"
export * from "./ViewFournisseur.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__